@if (formControl()) {
<div class="key form-group">
    <mat-form-field class="form-field">
        <input matInput [readonly]="meta().readonly" [placeholder]="meta().name"
            [formControl]="$any(formArray()?.at(arrayIndex() ?? 0) || formControl())">
        @if (formControl()?.value && !meta()?.readonly) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
            <mat-icon>close</mat-icon>
        </button>
        }
        @if (meta()?.info) {
        <mat-hint><strong>{{meta()?.info}}</strong></mat-hint>
        }
        @if (formControl()?.hasError('pattern') && !formControl()?.hasError('required')) {
        <mat-error>
            Key is invalid
        </mat-error>
        }
        @if (formControl()?.hasError('required')) {
        <mat-error>
            Key can not be empty.
        </mat-error>
        }
        @if (formControl()?.hasError('callback') && !formControl()?.hasError('required')) {
        <mat-error>
            Duplicate key found.
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
